<div class="quotations-root">
  <div class="head">

    <form action="" class="search">
      <input type="search" (keyup)="searchEvent($event)" />
      <i class="fas fa-search">
        <img class="search-icon" src="/assets/images/search-logo.svg" />
      </i>
    </form>
  </div>

  <ng-container *ngIf="!isLoaded">
    <div>
      <p> Chargement en cours ...</p>
    </div>
  </ng-container>

  <ng-container *ngIf="isLoaded">
    <div class="list">
      <h2 class="title">Devis</h2>
      <ul>
        <ng-container *ngFor="let quotation of filteredQuotations">
          <li *ngIf="calculateTTC(quotation) > 0" class="li-no-bullet quotations">
            <a class="naviguate-auth" href="{{openQuotation(quotation)}}" target="_blank">
              <div class="row li-content">
                <div class="col-8 col-sm-4">
                  <div class="quote-title">{{ quotation.version.title || 'Sans titre' }}</div>
                </div>
                <div class="col-3 label d-none d-sm-block">{{ calculateTTC(quotation) | currency: 'EUR' }}</div>

                <div class="col">
                  <button type="button" class="action">
                    <span class="image"><img src="/assets/images/see-quotation-icon.svg" /></span>
                    <span class="text d-none d-sm-block">Voir le devis</span>
                  </button>
                </div>
              </div>
            </a>
          </li>
        </ng-container>
      </ul>
    </div>

    <div *ngIf="isEmpty() === true" class="empty">
      <p>Aucun devis trouvé</p>
    </div>
  </ng-container>

</div>
